__turbopack_context__.v({
  "appIcon": "UbsValidateDialog-module__nWppDW__appIcon",
  "body": "UbsValidateDialog-module__nWppDW__body",
  "chevron": "UbsValidateDialog-module__nWppDW__chevron",
  "column": "UbsValidateDialog-module__nWppDW__column",
  "columnTight": "UbsValidateDialog-module__nWppDW__columnTight",
  "connectDisplayWrapper": "UbsValidateDialog-module__nWppDW__connectDisplayWrapper",
  "fullWidthSelect": "UbsValidateDialog-module__nWppDW__fullWidthSelect",
  "header": "UbsValidateDialog-module__nWppDW__header",
  "loadingContainer": "UbsValidateDialog-module__nWppDW__loadingContainer",
  "rotated": "UbsValidateDialog-module__nWppDW__rotated",
  "titleBlock": "UbsValidateDialog-module__nWppDW__titleBlock",
  "validationAccordion": "UbsValidateDialog-module__nWppDW__validationAccordion",
  "validationAccordionContent": "UbsValidateDialog-module__nWppDW__validationAccordionContent",
  "validationAccordionHeader": "UbsValidateDialog-module__nWppDW__validationAccordionHeader",
  "validationItemContent": "UbsValidateDialog-module__nWppDW__validationItemContent",
  "validationList": "UbsValidateDialog-module__nWppDW__validationList",
  "validationListContainer": "UbsValidateDialog-module__nWppDW__validationListContainer",
  "validationListItem": "UbsValidateDialog-module__nWppDW__validationListItem",
});
